<div fxLayout="column" fxFlex="1 0 auto">
  <div fxLayout="column" class="neq-page-wrapper">
    <ng-container *ngIf="!importSemiAutoIsOnGoing">
      <div fxLayout="row">
        <div fxLayoutAlign="start center" class="neq-action-button">
          <button
            pButton
            class="neq-primeng-button primeng-flat"
            (click)="resetFilter()"
            [matTooltip]="'msg.common.icon.filter.reset' | translate"
          >
            <neq-icon svgIcon="filter-slash"></neq-icon>
          </button>
          <mat-checkbox (change)="displayArchivedRawMaterials()"
                        [checked]="displayArchivedRawMat"
                        *hasRights="archiveOrDesarchiveRight">
            {{ 'msg.common.icon.rawmaterial.display.rawmaterial' | translate }}
          </mat-checkbox>
          <mat-checkbox (change)="displayDisabledRawMaterials()"
                        [checked]="displayDisabledRawMat"
                        style="margin-left: 10px;"
                        *hasRights="enableDisableRight">
            {{ 'msg.common.icon.rawmaterial.display.disabled' | translate }} </mat-checkbox>

          <mat-checkbox (change)="displayRMWaitingForCalculation()" style="margin-left: 10px;">{{ 'msg.common.icon.rawmaterial.display.waiting-for-calculation' | translate }}</mat-checkbox>
          <div *ngIf="isAdvancedSearchResult()" fxLayoutAlign="start end" class="advanced-search-result-div">
            <div fxLayout="row" fxLayout="start center" fxLayoutGap="0.714rem">
              <div>{{ 'label.user.rawmaterials.list.advanced-search-result' | translate }}</div>
              <div><em (click)="leaveAdvancedSearchResult()" (keyDown)="leaveAdvancedSearchResult()" class="fas fa-times"></em></div>
            </div>
          </div>
        </div>
        <div fxFlex></div>
        <div fxLayoutAlign="end center" class="neq-action-button">

          <button pButton style="margin-right: 15px;"
                  *hasRights="calculateRight"
                  class="neq-primeng-button primeng-flat"
                  routerLink="/app/rawmaterials/create"
                  [matTooltip]="'msg.common.icon.rawmaterial.create' | translate"
          >
            <neq-icon svgIcon="plus"></neq-icon>
          </button>

          <button pButton style="margin-right: 15px;"
                  *hasRights="calculateRight"
                  class="neq-primeng-button primeng-flat"
                  [matTooltip]="'msg.common.icon.rawmaterial.multiselection' | translate"
                  (click)="onClickMultiselection()"
                  [disabled]="!canUseMultiselection()"
          >
            <neq-icon svgIcon="list-check"></neq-icon>
          </button>

          <button pButton
                  *hasRights="fullAutoRm"
                  class="neq-primeng-button primeng-flat"
                  [matTooltip]="'msg.user.rawmaterial.icon.import.full-auto' | translate"
                  [matMenuTriggerFor]="fullAutoImportMenu"
          >
            <neq-icon svgIcon="import-full-auto"></neq-icon>
          </button>

          <mat-menu #fullAutoImportMenu="matMenu">
            <button mat-menu-item (click)="onOpenImportFullAutoCreation()" *hasRights="fullAutoRmCreate">
              {{ 'msg.user.rawmaterial.action.full-auto-import-creation' | translate }}
            </button>
            <button mat-menu-item (click)="onOpenImportFullAutoModification()" *hasRights="fullAutoRmModify">
              {{ 'msg.user.rawmaterial.action.full-auto-import-modification' | translate }}
            </button>
          </mat-menu>

          <button pButton
                  *hasRights="semiAutoRm"
                  class="neq-primeng-button primeng-flat"
                  [matTooltip]="'msg.user.rawmaterial.icon.import.semi-auto' | translate"
                  [matMenuTriggerFor]="semiAutoImportMenu"
          >
            <neq-icon svgIcon="import-semi-auto"></neq-icon>
          </button>

          <mat-menu #semiAutoImportMenu="matMenu">
            <button mat-menu-item *hasRights="semiAutoRmCreate" (click)="startImportCreateSemiauto()">
              {{ 'msg.user.rawmaterial.action.semi-auto-import-creation' | translate }}
            </button>
            <button mat-menu-item *hasRights="semiAutoRmModify" (click)="startImportModifySemiauto()">
              {{ 'msg.user.rawmaterial.action.semi-auto-import-modification' | translate }}
            </button>
          </mat-menu>

          <button pButton
                  *ngIf="exportEnabled()"
                  [disabled]="!canExport()"
                  class="neq-primeng-button primeng-flat"
                  (click)="exportRequest()"
                  [matTooltip]="'msg.common.icon.rawmaterial.export' | translate"
          >
            <neq-icon svgIcon="exporter"></neq-icon>
          </button>

          <button pButton
                  *ngIf="calculateBatchEnabled()"
                  [disabled]="!canCalculateBatch()"
                  class="neq-primeng-button primeng-flat"
                  (click)="calculateBatch()"
                  [matTooltip]="'msg.common.icon.rawmaterials.calculation.batch' | translate"
          >
            <neq-icon svgIcon="calcul"></neq-icon>
          </button>

          <button pButton
                  *hasRights="editMassRm"
                  (click)="navigateToMultiEditPage()"
                  [disabled]="!canMultiEdit()"
                  class="neq-primeng-button primeng-flat"
                  [matTooltip]="'msg.common.icon.rawmaterial.multiEdit' | translate">
            <neq-icon svgIcon="editer"></neq-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <neq-table *ngIf="!importSemiAutoIsOnGoing && showTable"
      [sessionId]="RAW_MAT_LIST_SESSION_ID"
      [activeFilter]="true"
      [selectableRows]="true"
      [disableSelectableCell]="isRawMaterialExportDisabled"
      [actions]="'user'"
      [cols]="rmCols"
      [onRequestData]="refreshTable"
      [noPagination]="false"
      [rowClass]="calculateRowCssClass" fxFlex>
    </neq-table>
    <neq-table *ngIf="importSemiAutoIsOnGoing && showTable"
      [sessionId]="SEMI_AUTO_SESSION_ID"
      [activeFilter]="true"
      [lazy]="false"
      [selectableRows]="false"
      [cols]="semiautoImportCols"
      [onRequestData]="refreshTable"
      [noPagination]="true"
      [rowClass]="calculateRowCssClass" fxFlex>
    </neq-table>
  </div>
</div>
